// For Footer menu

$(document).ready(function() {
  var w=$(window).width();
  if (w < 575 ){
    $('.footer .thb-widget-title').click(function() {
        $(this).next().slideToggle("slow");
      	$(this).toggleClass("open-menu");
    });
  }
   setTimeout(function() {
    $('.spr-reviews').flickity({
      // options
      contain: true,
      autoPlay: true,
      groupCells: 3,
      pageDots: false
      });
  }, 2500);

// $('.press-module-inner ul').flickity({
//   // options
//   freeScroll: true,
//   contain: true,
//   prevNextButtons: false,
//   pageDots: true,
//   groupCells: '4',
//   autoPlay: true,
// });

$('.image-slider-inner').flickity({
  // options
  freeScroll: true,
  contain: true,
  prevNextButtons: true,
  pageDots: false,
  autoPlay: true,
  wrapAround: true,
});
// 1st carousel, main
$('.value-slider-main .slider-inner').flickity({
  contain: true,
  pageDots: true,
  prevNextButtons: false,
});
  
// 2nd carousel, navigation
$('.value-slider-nav').flickity({
  asNavFor: '.slider-inner',
  contain: false,
  pageDots: false,
  prevNextButtons: false,
  groupCells: '4'
});
  
var timer = setInterval(function(){
  if($(".usf-pro-wraper").length > 0){
    $(".usf-pro-wraper").each(function(){
      var pro_color = $(this).find(".usf-title").children("a").text();
      $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
    });
    clearInterval(timer);
  }
},200);

var timer_load = setInterval(function(){
    if($(".usf-load-more").length > 0){
       $(".usf-load-more").click(function(){
        setTimeout(function () {
          if($(".usf-pro-wraper").length > 0){
            $(".usf-pro-wraper").each(function(){
              var pro_color = $(this).find(".usf-title").children("a").text();
              $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
            });
          }
        }, 1000);
      });
      clearInterval(timer_load);
    }
  },200);
  
    var timer_load1 = setInterval(function(){
    if($(".usf-btn.usf-relative").length > 0){
       $(".usf-btn.usf-relative").click(function(){
        setTimeout(function () {
          if($(".usf-pro-wraper").length > 0){
            $(".usf-pro-wraper").each(function(){
              var pro_color = $(this).find(".usf-title").children("a").text();
              $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
            });
          }
        }, 1000);
      });
      clearInterval(timer_load1);
    }
  },200);

   var timer_load2 = setInterval(function(){
    if($(".usf-refineby__item").length > 0){
        debugger
       $(".usf-refineby__item").click(function(){
        setTimeout(function () {
          if($(".usf-pro-wraper").length > 0){
            $(".usf-pro-wraper").each(function(){
              var pro_color = $(this).find(".usf-title").children("a").text();
              $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
            });
          }
        }, 1000);
      });
      clearInterval(timer_load2);
    }
  },200);

var timer_load3 = setInterval(function(){
    if($(".usf-clear-all.usf-btn").length > 0){
        debugger
       $(".usf-clear-all.usf-btn").click(function(){
        setTimeout(function () {
          if($(".usf-pro-wraper").length > 0){
            $(".usf-pro-wraper").each(function(){
              var pro_color = $(this).find(".usf-title").children("a").text();
              $(this).addClass(pro_color.replace(/\s/g, '').toLowerCase());
            });
          }
        }, 1000);
      });
      clearInterval(timer_load3);
    }
  },200);

});
$("input[data-name=Color]").change(function(){
  console.log($(this).val());
  if ($(this).val() == 'Periwinkle') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#c4c0de');
  }else if ($(this).val() == 'Blue') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#176fdb');
  }else if ($(this).val() == 'Lavender') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#d2a3d9');
  }else if ($(this).val() == 'Mint') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#b2dbc2');
  }else if ($(this).val() == 'Gold') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#e7dbcc');
  }else if ($(this).val() == 'Orchid') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#e5a3b0');
  }else if ($(this).val() == 'Aqua') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#7ad4cf');
  }else if ($(this).val() == 'Silver') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#c9c8c8');
  }else if ($(this).val() == 'Indigo') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#31516d');
  }else if ($(this).val() == 'White') {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  '#ebebeb');
  }
  else {
    $('.thb-product-detail.product .product-images-wrap').css('background-color',  $(this).val());
  }
});

$(document).ready(function() {
$('.press-module-inner ul').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        slidesToShow: 2,
      }
    },
  ]
});
  
  // product-text-slider
  
  $('.product-text-slider .pts-inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
  });
});
$(document).ready(function() {
  var maxHeight = 0;
  $(".eq-height>div:not(.rb-btn)").each(function(){
     if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".eq-height>div:not(.rb-btn)").height(maxHeight);
});
$(document).ready(function(){
  $('a.flip-btn').on('click', function () {
    $(this).parent().parent().parent().find('.card, .rb-btn').toggleClass('flipped');
  });
  $('a.flips-btn').on('click', function () {
    $(this).parent().toggleClass('flipped');
  });
});

$(function() {
    $('.popup-youtube').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
    $('.video-popup').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
});

// for tab js

function openTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent-cus");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks-cus");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
if (document.getElementById("tab-cus-active") != null) {
  document.getElementById("tab-cus-active").click();
}
/* =====================================================================
   PhoneSoap - Quick-view: show the SELECTED color's image
   ===================================================================== */
(function () {
  var DRAWER_ID = 'Product-Drawer';

  function norm(s) {
    return (s || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
  }
  function baseName(url) {
    if (!url) return '';
    var f = url.split('?')[0].split('#')[0].split('/').pop() || '';
    return norm(f.replace(/\.(jpe?g|png|webp|gif|avif)$/i, ''));
  }

  function getDrawer() { return document.getElementById(DRAWER_ID); }

  function getVariants(drawer) {
    try {
      var tag = drawer.querySelector('variant-selects script[type="application/json"]');
      if (!tag) return [];
      var data = JSON.parse(tag.textContent);
      return Array.isArray(data) ? data : [];
    } catch (e) { return []; }
  }

  function selectedColor(drawer) {
    var c = drawer.querySelector('.product-form__input--color input[type="radio"]:checked');
    return c ? norm(c.value) : '';
  }

  function featuredForColor(drawer, sel) {
    var vs = getVariants(drawer);
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      var opts = [v.option1, v.option2, v.option3];
      var hit = false;
      for (var j = 0; j < opts.length; j++) { if (norm(opts[j]) === sel) { hit = true; break; } }
      if (!hit && norm(v.title) === sel) hit = true;
      if (hit && v.featured_image && v.featured_image.src) return baseName(v.featured_image.src);
    }
    return '';
  }

  function slideAlt(slide) {
    var img = slide.querySelector('img');
    return img ? norm(img.getAttribute('alt')) : '';
  }
  function slideName(slide) {
    var u = slide.getAttribute('data-full');
    if (!u) {
      var img = slide.querySelector('img');
      u = img ? (img.getAttribute('data-srcset') || img.getAttribute('data-src') || img.currentSrc || img.src) : '';
    }
    return baseName(u);
  }

  function forceLoad(slide) {
    var img = slide.querySelector('img');
    if (!img || img.getAttribute('data-qvloaded') === '1') return;
    var full = slide.getAttribute('data-full');
    var ds = img.getAttribute('data-srcset');
    if (ds) img.setAttribute('srcset', ds);
    if (full) { img.src = full; }
    else { var d = img.getAttribute('data-src'); if (d) img.src = d; }
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
    img.setAttribute('data-qvloaded', '1');
  }

  function filterGallery(drawer) {
    if (!drawer) return;
    var slider = drawer.querySelector('#Product-Quick-Slider') ||
                 drawer.querySelector('.product-quick-images');
    if (!slider) return;
    var slides = Array.prototype.slice.call(
      slider.querySelectorAll('.product-quick-images__slide:not(.slick-cloned)')
    );
    if (slides.length < 2) return;

    var sel = selectedColor(drawer);
    if (!sel) { slides.forEach(function (s) { s.style.display = ''; }); return; }

    var featured = featuredForColor(drawer, sel);

    var chosen = null, i;
    for (i = 0; i < slides.length && !chosen; i++) {
      if (featured && slideName(slides[i]) === featured) chosen = slides[i];
    }
    if (!chosen && sel.length > 1) {
      for (i = 0; i < slides.length && !chosen; i++) {
        if (slideAlt(slides[i]).indexOf(sel) > -1) chosen = slides[i];
      }
    }
    if (!chosen && sel.length > 1) {
      for (i = 0; i < slides.length && !chosen; i++) {
        if (slideName(slides[i]).indexOf(sel) > -1) chosen = slides[i];
      }
    }

    if (!chosen) { slides.forEach(function (s) { s.style.display = ''; }); return; }

    forceLoad(chosen);
    slides.forEach(function (s) { s.style.display = (s === chosen) ? '' : 'none'; });
    if (slider.firstElementChild !== chosen) {
      try { slider.insertAdjacentElement('afterbegin', chosen); } catch (e) {}
    }
    try { slider.scrollLeft = 0; } catch (e) {}
  }

  function run(drawer) { setTimeout(function () { filterGallery(drawer); }, 60); }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('#' + DRAWER_ID + ' .product-form__input--color input[type="radio"]')) {
      run(getDrawer());
    }
  });

  function watch() {
    var drawer = getDrawer();
    if (!drawer) { return; }
    var mo = new MutationObserver(function () {
      if (drawer.classList.contains('active') || drawer.querySelector('#Product-Quick-Slider')) {
        run(drawer);
      }
    });
    mo.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    run(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
/* =====================================================================
   PhoneSoap - Remove redundant native "title" tooltips on product cards.
   ===================================================================== */
(function () {
  function strip() {
    var els = document.querySelectorAll(
      '.product-card [title], a.product-card-title[title], .product-featured-image-link[title], .product-card a[title]'
    );
    els.forEach(function (el) { el.removeAttribute('title'); });
  }
  function init() {
    strip();
    [300, 1000, 2500].forEach(function (t) { setTimeout(strip, t); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* =====================================================================
   PhoneSoap - Two-line product-card titles on collection pages.
   line 1 = bold short name, line 2 = muted benefit tagline.

   Each product is matched by its /products/<handle> URL to a curated
   name + shopper-benefit tagline (mirrors the mega-nav). Anything not in
   the map (bundles, refurbs, cables, etc.) falls back to splitting the
   product title on the colon; titles with no colon show the name only.

   Display-only: the real product title, H1, and Google Shopping feed are
   never touched. Paste at the END of assets/custom.js. Remove to revert.
   ===================================================================== */
(function () {
  if (!document.body || document.body.className.indexOf('template-collection') === -1) return;

  // handle (the /products/<handle> slug)  ->  { name, tag }
  var MAP = {
    'phonesoap-3-phone-uv-sanitizer': { name: 'PhoneSoap 3',        tag: 'Original sanitizer + charger' },
    'phonesoap-pro':                  { name: 'PhoneSoap Pro',      tag: 'Faster, fits larger phones' },
    'phonesoap-basic-phone-uv-sanitizer': { name: 'PhoneSoap Basic', tag: 'Sanitizer, no charger' },
    'homesoap':                       { name: 'HomeSoap',           tag: 'Largest capacity' },
    'uv-c-baby-bottle-sanitizer-dryer': { name: 'PhoneSoap Baby',   tag: 'Sanitizer + dryer' },
    'phonesoap-go':                   { name: 'PhoneSoap Go',       tag: 'Battery-powered, doubles as a power bank' },
    'phonesoap-3-wireless-charger':   { name: 'PhoneSoap Wireless', tag: 'Qi wireless charging' },
    'uv-toothbrush-sanitizer':        { name: 'UV Toothbrush Sanitizer', tag: 'Sanitizes + dries' },
    'luma-bottle':                    { name: 'Luma',               tag: 'Kills germs in your water' },
    'straws':                         { name: 'The Last Straw',     tag: 'Cleans inside & out' },
    'washclock':                      { name: 'WashClock',          tag: 'Handwashing timer for kids' },
    'express-pro':                    { name: 'ExpressPro',         tag: 'Rapid commercial UV' },
    'express-pro-wall-mount':         { name: 'ExpressPro Mounts',  tag: 'Wall & stand options' },
    'phonesoap-shine':                { name: 'PhoneSoap Shine',    tag: 'Screen cleaner spray + cloth' },
    'antimicrobial-charging-cable':   { name: 'Antimicrobial Cables', tag: 'USB-C & Lightning' },
    'airsoap':                        { name: 'AirSoap X3',         tag: 'Filterless, up to 800 sq ft' },
    'airsoap-x5':                     { name: 'AirSoap X5',         tag: 'Filterless, for large rooms' }
  };

  function handleFrom(a) {
    var href = a.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function apply() {
    var titles = document.querySelectorAll('.featured-collection .product-card-title');
    titles.forEach(function (a) {
      if (a.getAttribute('data-twoline') === '1') return;

      var name, tag;
      var mapped = MAP[handleFrom(a)];
      if (mapped) {
        name = mapped.name;
        tag  = mapped.tag;
      } else {
        // Fallback: split the product title on the first colon.
        var full = (a.textContent || '').trim();
        var i = full.indexOf(':');
        name = i > 0 ? full.slice(0, i).trim() : full;
        tag  = i > 0 ? full.slice(i + 1).trim() : '';
      }

      a.textContent = '';

      var nameEl = document.createElement('span');
      nameEl.className = 'pc-name';
      nameEl.textContent = name;
      a.appendChild(nameEl);

      if (tag) {
        var tagEl = document.createElement('span');
        tagEl.className = 'pc-tag';
        tagEl.textContent = tag;
        a.appendChild(tagEl);
      }

      a.setAttribute('data-twoline', '1');
    });
  }

  function init() {
    apply();
    [300, 1000, 2500].forEach(function (t) { setTimeout(apply, t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* =====================================================================
   PhoneSoap - Sticky subnav "Add to cart" -> actually add to cart.
   ===================================================================== */
(function () {
  if (window.__psSubnavATC) return;
  window.__psSubnavATC = true;

  function sectionOf(el) {
    return el.closest('.shopify-section') ||
           el.closest('[id^="shopify-section-"]') ||
           document;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.sub-buy a.btn, .buybar a.btn');
    if (!trigger) return;

    var href = trigger.getAttribute('href') || '';
    if (href && href.charAt(0) !== '#') return;

    var section = sectionOf(trigger);
    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();

    var btn = form.querySelector(
      'button[type="submit"], input[type="submit"], button[name="add"], .single_add_to_cart_button, .btn-cart[type="submit"]'
    );
    if (btn) {
      btn.click();
    } else if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }, true);
})();
/* =====================================================================
   PhoneSoap - Out-of-stock color swatches (all product pages).
   ===================================================================== */
(function () {
  if (window.__psOOS) return;
  window.__psOOS = true;
  if (location.pathname.indexOf('/products/') !== 0) return;

  var handle = location.pathname.split('/products/')[1];
  handle = handle ? handle.split('/')[0].split('?')[0] : '';
  if (!handle) return;

  function labelOf(radio) { return radio.closest('label') || radio.parentNode; }

  function apply(avail) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      var radios = form.querySelectorAll('input[type="radio"][name="id"]');
      if (radios.length < 2) return;

      radios.forEach(function (r) {
        if (avail[String(r.value)] === false) {
          var lbl = labelOf(r);
          lbl.classList.add('ps-oos');
          r.setAttribute('data-oos', '1');
          r.disabled = true;
          if (!lbl.querySelector('.ps-oos-tag')) {
            var t = document.createElement('span');
            t.className = 'ps-oos-tag';
            t.textContent = 'Sold out';
            lbl.appendChild(t);
          }
        }
      });

      var container = labelOf(radios[0]).parentNode;
      [].slice.call(radios).forEach(function (r) {
        var lbl = labelOf(r);
        if (lbl.classList.contains('ps-oos') && lbl.parentNode === container) {
          container.appendChild(lbl);
        }
      });

      function updateBtn() {
        var checked = form.querySelector('input[name="id"]:checked');
        var oos = checked && checked.getAttribute('data-oos') === '1';
        var btns = form.querySelectorAll(
          'button[type="submit"], input[type="submit"], .btn-cart, .single_add_to_cart_button'
        );
        btns.forEach(function (b) {
          if (oos) {
            if (!b.getAttribute('data-ps-html')) b.setAttribute('data-ps-html', b.innerHTML);
            b.textContent = 'Sold Out';
            b.setAttribute('disabled', 'disabled');
            b.classList.add('ps-btn-oos');
          } else {
            if (b.getAttribute('data-ps-html')) b.innerHTML = b.getAttribute('data-ps-html');
            b.removeAttribute('disabled');
            b.classList.remove('ps-btn-oos');
          }
        });
      }
      form.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'id') updateBtn();
      });
      updateBtn();
    });
  }

  fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      var m = {};
      (p.variants || []).forEach(function (v) { m[String(v.id)] = !!v.available; });
      apply(m);
    })
    .catch(function () {});
})();
/* =====================================================================
   PhoneSoap - Two-line product-page H1.
   Splits the product-page title on the first colon and renders:
     line 1 = bold product name   (e.g. "PhoneSoap Go")
     line 2 = smaller grey descriptor  (e.g. "Portable UV Sanitizer & Power Bank")
   The FULL H1 text is preserved inside the <h1> (both parts stay in the
   heading), so the H1, SEO, and Google Shopping are unaffected â€” this only
   changes how the existing title is displayed. Titles with no colon are
   left exactly as-is.
   Paste at the END of assets/custom.js. Remove this block to revert.
   ===================================================================== */
(function () {
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  function splitH1() {
    var hs = document.querySelectorAll('h1');
    for (var k = 0; k < hs.length; k++) {
      var h = hs[k];
      // Only the main product title: skip any H1 in the header/nav/footer.
      if (h.closest && h.closest('header, .header, #shopify-section-header, nav, footer, .footer, .site-footer')) continue;
      if (h.getAttribute('data-twoline') === '1') continue;

      var full = (h.textContent || '').trim();
      var i = full.indexOf(':');
      if (i <= 0) { h.setAttribute('data-twoline', '1'); return; }  // no colon -> leave unchanged

      var name = full.slice(0, i).trim();
      var desc = full.slice(i + 1).trim();

      h.textContent = '';

      var nameEl = document.createElement('span');
      nameEl.className = 'ph-name';
      nameEl.textContent = name;
      h.appendChild(nameEl);

      var descEl = document.createElement('span');
      descEl.className = 'ph-desc';
      descEl.textContent = desc;
      h.appendChild(descEl);

      h.setAttribute('data-twoline', '1');
      return;  // handle only the first (main) title
    }
  }

  function init() {
    splitH1();
    [300, 1000].forEach(function (t) { setTimeout(splitH1, t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* =====================================================================
   PhoneSoap - "NEW" badge on PhoneSoap Baby (mega-nav + collection cards).
   Display-only. Paste at the END of assets/custom.js (after the
   two-line card-names script). Delete this block once Baby is no longer new.
   To badge a different/additional product later, add its handle to HANDLES.
   ===================================================================== */
(function () {
  var HANDLES = ['uv-c-baby-bottle-sanitizer-dryer'];

  function isBaby(href) {
    if (!href) return false;
    for (var i = 0; i < HANDLES.length; i++) {
      if (href.indexOf('/products/' + HANDLES[i]) !== -1) return true;
    }
    return false;
  }
  function badge() {
    var s = document.createElement('span');
    s.className = 'thb-new-badge';
    s.textContent = 'New';
    return s;
  }
  function add(target, link) {
    if (link.getAttribute('data-newbadge') === '1') return;
    target.appendChild(badge());
    link.setAttribute('data-newbadge', '1');
  }

  function run() {
    // 1) Mega-nav / header menu links -> badge next to the name
    document.querySelectorAll('header a[href], nav a[href]').forEach(function (a) {
      if (!isBaby(a.getAttribute('href'))) return;
      if (a.closest('.product-card')) return;                 // handled below
      add(a.querySelector('span') || a, a);                   // first span = name line
    });

    // 2) Collection grid cards -> badge next to the two-line name
    document.querySelectorAll('.product-card a.product-card-title[href]').forEach(function (a) {
      if (!isBaby(a.getAttribute('href'))) return;
      add(a.querySelector('.pc-name') || a, a);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  [400, 1200, 2500].forEach(function (t) { setTimeout(run, t); });
})();